import React, { useState } from 'react';
import galleryImages from '../data/galleryImages';
import './GalleryPage.css';

const GalleryPage = ({ returnHome }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <main className="gallery-page">
      <section className="gallery-hero">
        <div className="container">
          <button type="button" className="gallery-back-button" onClick={returnHome}>
            <span aria-hidden="true"></span>
            Back to Home
          </button>
          <div className="gallery-page-header animate-fade-in-up">
            <p className="gallery-kicker">Totalguard Gallery</p>
            <h1>Product Gallery</h1>
            <p>
              View the full Totalguard Workwear Rosslyn product range, including protective clothing,
              technical wear, freezer jackets, safety footwear, and workplace PPE essentials.
            </p>
          </div>
        </div>
      </section>

      <section className="gallery-all">
        <div className="container">
          <div className="gallery-all-grid">
            {galleryImages.map((image) => (
              <button
                className="gallery-card"
                key={image.id}
                type="button"
                onClick={() => setSelectedImage(image)}
                aria-label={`Open ${image.alt}`}
              >
                <img src={image.src} alt={image.alt} loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      </section>

      {selectedImage && (
        <div
          className="gallery-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Product image preview"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="gallery-lightbox-close"
            type="button"
            onClick={() => setSelectedImage(null)}
            aria-label="Close image preview"
          >
            <span></span>
            <span></span>
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </main>
  );
};

export default GalleryPage;
